<div class="w-full h-full">
    <div class="flex items-center justify-between space-x-3 pt-9 text-sm">
        <div class="flex items-center space-x-3 text-xs"></div>
        <div class="flex items-center space-x-3 text-xs"></div>
    </div>

    <div class="w-900-px mx-auto">
        <div class="grid grid-cols-12 gap-6">
            <!-- Restrict Words Input -->
            <div class="col-span-6 space-y-5">
                <div class="card-input flex items-start text-xs py-2 w-full">
                    <span class="text-xs w-300-px font-semibold">
                        Restrict the following words:
                    </span>
                    <textarea 
                        [(ngModel)]="wordsToRestrict"
                        [disabled]="isLoading"
                        class="placeholder-black focus:outline-none w-full h-90-px bg-gray-100 rounded-md pl-3 pt-2 resize-none italic" 
                        placeholder="Enter words to restrict (e.g word1, word2, word3, ...)" 
                        cols="30" 
                        rows="10">
                    </textarea>
                </div>
            </div>

            <!-- Allow Words Input -->
            <div class="col-span-6 space-y-5">
                <div class="card-input flex items-start text-xs py-2 w-full">
                    <span class="text-xs w-300-px font-semibold">
                        Allow the following words:
                    </span>
                    <textarea 
                        [(ngModel)]="wordsToAllow"
                        [disabled]="isLoading"
                        class="placeholder-black focus:outline-none w-full h-90-px bg-gray-100 rounded-md pl-3 pt-2 resize-none italic" 
                        placeholder="Enter words to allow (e.g word1, word2, word3, ...)" 
                        cols="30" 
                        rows="10">
                    </textarea>
                </div>
            </div>
        </div>
    </div>

    <!-- Add Button -->
    <div class="w-full flex items-center justify-center mt-6 mb-4">
        <button 
            (click)="onAddButtonClick()"
            [disabled]="isLoading"
            class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2 disabled:opacity-50 disabled:cursor-not-allowed">
            Add
        </button>
    </div>

    <!-- List of Prohibited Words -->
    <div class="w-700-px mx-auto mt-8">
        <div class="text-m font-semibold">List of prohibited words:</div>
        
        <!-- Loading State -->
        <div *ngIf="isLoading && profanityWords.length === 0" class="px-7 mt-3 text-xs text-gray-500">
            Loading...
        </div>

        <!-- Empty State -->
        <div *ngIf="!isLoading && profanityWords.length === 0" class="px-7 mt-3 text-xs text-gray-500">
            No prohibited words found.
        </div>

        <!-- Words List -->
        <ul class="px-7 mt-3" *ngIf="profanityWords.length > 0">
            <div class="grid grid-cols-3 gap-1">
                <div class="col-span-1" *ngFor="let item of profanityWords">
                    <li class="text-xs">{{ item.word }}</li>
                </div>
            </div>
        </ul>
    </div>
</div>
<ngx-spinner type="border" size="medium">
      <app-megapay-loader></app-megapay-loader>
</ngx-spinner>